import React, { useEffect, useState } from "react";
import CText from "../../common/CText";
import { ScrollView, TouchableOpacity, View, Text } from "react-native";
import MainContainer from "./CommonComponants/MainContainer";
import CHeader from "./CommonComponants/Header";
import CustomButton from "../../common/CustomButton";
import InsurancePlanCard from "./InsurancePlanCard";
import InsurancePlanDesc from "./InsurancePlanDesc";
import CCheckbox from "../../common/CCheckBox";
import CDivider from "../../common/CDivider";
import { getActivePlans } from "../../api/tripInsurance";
import {  isCommVehcle, priceBreakUp } from "../../api/apiManager";
import ModalAlert from "../../common/ModalAlert";
import Loader from "../../common/Loader";
import useStyles from "./Benifits_Styles";
import CDocxViewer from "../../common/CDocxViewer";

export default function Benifits(props) {
  console.log("props Benifits ", props)
  const data = props?.data || {};
  const info = props?.info || {};
  const styles = useStyles();
  const [selectedPlan, setSelectedPlan] = useState("");
  const [selectedPlanObj, setSelectedPlanObj] = useState({});
  const [activePlans, setActivePlans] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(false);
  const [tncModalVisible, setTncModalVisible] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: "",
  });

  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

   const refreshTripInsurancePlan = (planData) => {
    const newPlanData = { ...planData };
    if (typeof planData !== "undefined") {
        const tiPlanType = getTripInsuranceType(planData);
        newPlanData["tiPlanType"] = tiPlanType;
        const effectiveInsurancePrice = (planData?.validityInDays === 1 && planData?.recurring) ? 0 : planData?.planPrice;
        newPlanData["tiPlanPrice"] = effectiveInsurancePrice;
    }
    return newPlanData;
}
 const getTripInsuranceType = (selectedPlan, includeWithObject) => {
  includeWithObject = includeWithObject || false;
  const tiTypeArr = ["none", "tiAnnual", "ti24R", "ti24S"];
  let tiReturnType = "";
  if (selectedPlan && selectedPlan?.validityInDays) {
      let tiIndex = 0;
        if (selectedPlan?.validityInDays === 1 && selectedPlan?.recurring) {
          tiIndex = 2;
      } else if (selectedPlan?.validityInDays === 1) {
          tiIndex = 3;
      }else{
        tiIndex = 1;
      }
      tiReturnType = tiTypeArr[tiIndex];
  }
  return tiReturnType;
}

  const activePlansList = () => {
    setLoading(true);
    getActivePlans({ useCase: info.useCase })
      .then((res) => {
        setLoading(false);
        if(res?.statusCode == 500 || res?.statusCode <0){
          setAlertModalVisible(true);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res?.message,
            navigateScreen: "",
            actionButton: "OK",
          });
        }else{
          const allActivePlans = res?.data?.activePlans;
          const refreshedPlans = allActivePlans.map(item => refreshTripInsurancePlan(item));
          setActivePlans(refreshedPlans);
        }
      })
      .catch((err) => { 
        setAlertModalVisible(true);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err?.message,
          navigateScreen: "",
          actionButton: "OK",
        });
      });
  };

  useEffect(() => {
    activePlansList();
  }, []);

  const onCardlick = (item, index) => {
    setSelectedPlanObj(item)
    setActiveIndex(index)
    setSelectedPlan(item.title);
    props.setData({ ...data, ...{ policyInfo: item, insuranceSkipped: false } });
  };
  const onSkipPress = () => {
    if (props?.info?.useCase == "Add-Vehicle") {
      onClickAddVehBtn()
      return;
    } else {
      props.setData({ ...data, ...{ insuranceSkipped: true } });
      props.setScreen(info.skipNavigation)
    }
  };

  const onClickAddVehBtn = () => {
    setLoading(true);
    let params = {
      status: props?.data?.addVehicleData?.status,
      userId: props?.data?.addVehicleData?.userId,
    };
    isCommVehcle(params)
      .then((res) => {
        if (
          (res.statusCode != 500 && res.statusCode > 0) ||
          res.statusCode != -1033
        ) {
          let reqObj = {
            vrn: props?.data?.addVehicleData?.vrn,
            vehicleClass: props?.data?.addVehicleData?.vehicleClass,
            mobileNo: props?.data?.addVehicleData?.mobileNo,
            tripInsurancePolicyCode: ""
          };
          priceBreakUp(reqObj)
            .then((res) => {
              setLoading(false);
              if (res.message == "Success!" || res.statusCode == 200) {
                const obj = { ...props.data, ...{ priceBreakUpData: res.data }, ...{ insuranceSkipped: true } }
                props.setData(obj)
                props.setScreen("PriceBreakup")
              }
              if (
                res.statusCode < 0 ||
                res.statusCode == 500 ||
                res.statusCode == -1033
              ) {
                setAlertModal({
                  title: "Error",
                  status: "error",
                  message: res.message,
                  navigateScreen: "",
                  actionButton: "OK",
                });
                setAlertModalVisible(true)
              }
            })
            .catch((err) => {
              setAlertModal({
                title: "Error",
                status: "error",
                message: err.message,
                navigateScreen: "",
                actionButton: "OK",
              });
              setAlertModalVisible(true)
              setLoading(false);
            });
        } else {
          setVcClassModal(false);
          setAlertModal({
            title: "Error",
            status: "error",
            message: res.message,
            navigateScreen: "",
            actionButton: "OK",
          });
          setAlertModalVisible(true)
        }
        setLoading(false);
      })
      .catch((err) => {
        setVcClassModal(false);
        setLoading(false);
        setAlertModal({
          title: "Error",
          status: "error",
          message: err.message,
          navigateScreen: "",
          actionButton: "OK",
        });
        setAlertModalVisible(true)
      });
  };

  const insuranceType = getTripInsuranceType(selectedPlan);

  return (
    <MainContainer>
      <View style={styles.contentWrapper}>
        <CHeader
          title="Trip Insurance (Add-on)"
          isShowSkipButton={info.showSkipButton && selectedPlan == ""}
          onSkipPress={() => onSkipPress()}
          onPress={() => props.setScreen(info.backNavigation)}
          showDesc={true}
        />
        <View style={styles.wrapper}>
          <View style={styles.bodyWrapper}>
            <View style={[styles.infoWrapper]}>
              <ScrollView showsVerticalScrollIndicator={false}>
                <InsurancePlanDesc type={selectedPlan} index={activeIndex} allActivePlans={activePlans} />
              </ScrollView>
            </View>
            <View style={[styles.insuranceCardWrapper, {}]}>
              <ScrollView showsVerticalScrollIndicator={false}>
                <CText.basicInformation>  Insurance (Add-on) </CText.basicInformation>
                <View style={styles.cardWrapper}>
                  {activePlans.length
                    ? activePlans.map((item, index) => {
                      return (
                        <InsurancePlanCard
                          key={index}
                          data={item}
                          isActive={selectedPlan == item.title && true}
                          isSelected={selectedPlan == item.title && true}
                          onPress={() => onCardlick(item, index)}
                        />
                      );
                    })
                    : null}
                </View>
              </ScrollView>
            </View>
          </View>
          <CDivider style={{ marginTop: 50 }} />
          <View>
            {selectedPlan ? (
              <View style={styles.tncWrapper}>
                {insuranceType == "tiAnnual" ? (
                  <CCheckbox
                    termsText={ `I hereby agree to have gone through the applicable `}
                    TermsAndCondition={"terms and conditions"}
                    termsText2={`and allow a debit of ₹${selectedPlanObj.planPrice} from my IDFC FIRST Bank FastTag Wallet towards the Accident Insurance Plan/Trip Insurance opted by me.`}
                    type={selectedPlan}
                    onPress={() => setTncModalVisible(true)}
                    setIsTermsChecked={setIsChecked}
                    isTermsChecked={isChecked}
                  />
                ) : insuranceType == "ti24R" ? (
                  <CCheckbox
                    termsText={  `I hereby agree to have gone through the applicable ` }
                    TermsAndCondition={"terms and conditions"}
                    termsText2={` and allow a debit of ₹${selectedPlanObj.planPrice} from my IDFC FIRST Bank FASTag Wallet towards the Accident Insurance Plan/Trip Insurance opted by me. I further give consent to authorise IDFC FIRST Bank to debit my IDFC FIRST Bank FASTag wallet with ₹${selectedPlanObj.planPrice} as per the plan opted to keep me insured at all time.`}
                    type={selectedPlan}
                    onPress={() => setTncModalVisible(true)}
                    setIsTermsChecked={setIsChecked}
                    isTermsChecked={isChecked}
                  />
                ) : "ti24S" ? (
                  <CCheckbox
                    termsText={`I hereby agree to have gone through the applicable ` }
                    TermsAndCondition={"terms and conditions"}
                    termsText2={` and allow a debit of ₹${selectedPlanObj.planPrice} from my IDFC FIRST Bank FASTag Wallet towards the Accident Insurance Plan/Trip Insurance opted by me.`}
                    type={selectedPlan}
                    onPress={() => setTncModalVisible(true)}
                    setIsTermsChecked={setIsChecked}
                    isTermsChecked={isChecked}
                  />
                ) : null}
              </View>
            ):null}
            <View style={styles.footer}>
              {info.showSkipButton && selectedPlan ? (
                <CustomButton
                  text="Skip for now"
                  skipButton={true}
                  onPress={() => onSkipPress()}
                />
              ):null}
              <View style={styles.proccedBtnWrapper}>
                <CustomButton
                  text="Proceed"
                  onPress={ selectedPlan == "" || !isChecked ? null : () => { props.setScreen("personalDetails"); } }
                  disable={selectedPlan == "" || !isChecked}
                />
              </View>
            </View>
          </View> 
        </View>
      </View>
      {tncModalVisible && <CDocxViewer type = "FF_TRIP_TNC" visibility={setTncModalVisible}/>}

{loading && <Loader />}

{alertModalVisible && (
 <View style={styles.overlayViewStyle}>
   <ModalAlert
     title={alertModal.title}
     status={alertModal.status}
     message={alertModal.message}
     navigateScreen={alertModal.navigateScreen}
     actionButton={"OK"}
     onCloseModal={onCloseModal}
   />
 </View>
)}
    </MainContainer>
  );
}
